import React, { useEffect, useState } from "react"
import { Navigate, useNavigate } from "react-router-dom"
import { verifyToken } from "../utils"

const ProtectedRoute = ({ children, setLoginStatus }) => {
    const [isValidToken, setIsValidToken] = useState(null)
    const navigate = useNavigate()
        

    useEffect(() => {
        const checkToken = async () => {
            if (!localStorage.getItem("authToken")) {
                setLoginStatus(false)
                setIsValidToken(false)
                return
            }

            const verificationResult = await verifyToken(localStorage.getItem("authToken"))
            const isTokenValid = !!verificationResult

            setIsValidToken(isTokenValid)
            setLoginStatus(isTokenValid)
        }

        checkToken()
    }, [navigate, setLoginStatus])

    if (isValidToken === null) {
        return <div>Loading...</div>

    } else if (!isValidToken){
        localStorage.removeItem("authToken")
        return <Navigate to="/login" />
    }

    return children
}

export default ProtectedRoute
